import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import QuoteModal from '@/components/PowerOcean/Home/QuoteModal';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic({ langKey }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <>
            {langKey === 'solarspeicher' && (
                <>
                    <B langKey={langKey} />
                    <C langKey={langKey} />
                    <H langKey={langKey} />
                    {/* <I langKey={langKey} /> */}
                    <J langKey={langKey} />
                    <D langKey={langKey} />
                    <E langKey={langKey} />
                    <F langKey={langKey} />
                    <G langKey={langKey} />
                    <K langKey={langKey} />
                    <L langKey={langKey} />
                    {['de'].includes(locale) && (
                        <div className="module-form power-ocean-collection-N">
                            <QuoteModal initType={1} langKey={'solarspeicher'} />
                        </div>
                    )}
                    <M langKey={langKey} />
                </>
            )}
            {langKey !== 'solarspeicher' && (
                <>
                    <D langKey={langKey} />
                    <B langKey={langKey} />
                    <C langKey={langKey} />
                    <E langKey={langKey} />
                    <F langKey={langKey} />
                    <G langKey={langKey} />
                    <H langKey={langKey} />
                    <I langKey={langKey} />
                    <J langKey={langKey} />
                    <K langKey={langKey} />
                    <L langKey={langKey} />
                    <M langKey={langKey} />
                </>
            )}
        </>
    );
}
